import { Card, RatingBarDial, RiskReturnSplitBarDial } from '@/components';
import { useYieldBearingAssets } from '@/components/providers';
import { YieldBearingAssetInterface } from '@/interfaces';
import { getTokenImageSrc } from '@/utils/functionalUtils';
import { FC, useEffect, useState } from 'react';
import YieldBearingAssetAdvancedDetailsButton from './YieldBearingAssetAdvancedDetailsButton';
interface Props {
  ticker: string;
}
const YieldBearingAssetPerformanceDetailCardHeader: FC<Props> = ({
  ticker,
}) => {
  const { yieldBearingAssets, loading } = useYieldBearingAssets();
  const [asset, setAsset] = useState<YieldBearingAssetInterface | null>(null);
  useEffect(() => {
    const foundAsset = yieldBearingAssets.find((a) => a.ticker === ticker);
    setAsset(foundAsset || null);
  }, [ticker, yieldBearingAssets]);
  const titleImageSrc = asset ? getTokenImageSrc(asset.ticker) : undefined;
  return (
    <Card.Header
      title={loading ? ticker : asset?.name}
      subTitle={asset?.ticker}
      {...(titleImageSrc && { titleImageSrc })}
      shouldHeaderLeftNodeIconHeightEqualHeightOfGroupOfTitleAndSubtitle
      rightNodeElements={
        asset
          ? [
              <RiskReturnSplitBarDial
                key="yield-bearing-asset-detail-risk-return-dial"
                asset={asset}
              />,
              <RatingBarDial
                key="yield-bearing-asset-detail-rating-dial"
                asset={asset}
              />,
              <YieldBearingAssetAdvancedDetailsButton
                key="yield-bearing-asset-detail-see-advanced-details-button"
                asset={asset}
              />,
            ]
          : []
      }
    />
  );
};
export default YieldBearingAssetPerformanceDetailCardHeader;
